import LinkTitleComponent from '72cms-ui/components/table-elements/LinkTitleComponent';
import CustomFilterComponent from '72cms-ui/components/helpers/CustomFilterComponent';
import ActiveSwitchActionComponent from '72cms-ui/components/table-elements/ActiveSwitchActionComponent';
import ThumbnailComponent from '72cms-ui/components/table-elements/ThumbnailComponent';
import ImportUserComponent from '../components/ImportUserComponent';

export default {
    fields: {
        // image: {
        //     label: 'Image',
        //     component: ThumbnailComponent,
        //     variant: 'w50',
        // },
        name: {
            component: LinkTitleComponent,
        },
        email: {

        },
        api_key_id: {

        },
        role: {
            component: {
                template: "<span>{{__(_.get(initialValue, 'name', ''), ['titleCase'])}}</span>",
                props: ['initialValue'],
            }
        }
    },
    sortable: ['name', 'email'],
    filterable: [],
    customFilters: [
        {
            name: 'Role',
            component: CustomFilterComponent,
            key: 'role_id',
            endpoint: '/roles/_ref_',
        }
    ],
    pagination: true,
    searchable: true,
    treeView: false,
    toolbar: [
        'create',
        {
            name: 'import_users',
            component: ImportUserComponent,
        },
    ],
    batchActions: [
        'active', 'delete',
    ],
    actions: [
        {
            name: 'edit',
            primary: true,
            component: 'edit-button',
        },
        {
            name: 'delete',
            component: 'delete-button',
        },
        {
            name: 'active',
            primary: true,
            component: ActiveSwitchActionComponent,
        },
    ]
}



// WEBPACK FOOTER //
// ./resources/assets/cms/js/config/collection.users.js